import { useState, createContext, useEffect } from "react"

const NavbarContext = createContext({
  account_menu_is_visible: false,
  search_is_visible: false,
  mobile_sidebar_is_visible: false,

  toggleAccountMenu: ()=>{},
  toggleSearch: ()=>{},
  toggleSidebar: ()=>{},
})

function NavbarContextProvider({ children }) {
  const [accountMenuVisible,setAccountMenuVisible] = useState(false),
        [searchVisible,setSearchVisible] = useState(false),
        [sidebarVisible,setSidebarVisible] = useState(false)

  function toggleAccountMenu() {
    setAccountMenuVisible(!accountMenuVisible)
    if(!accountMenuVisible) {
      setSidebarVisible(false)
      setSearchVisible(false)
    }
  }
  function toggleSearchVisible() {
    setSearchVisible(!searchVisible)
    if(!searchVisible) {
      setSidebarVisible(false)
      setAccountMenuVisible(false)
    }
  }
  function toggleSidebarVisible() {
    setSidebarVisible(!sidebarVisible)
    if(!sidebarVisible) {
      setSearchVisible(false)
      setAccountMenuVisible(false)
    }
  }

  return (
    <NavbarContext.Provider value={{
      account_menu_is_visible: accountMenuVisible,
      search_is_visible: searchVisible,
      mobile_sidebar_is_visible: sidebarVisible,
      toggleAccountMenu: toggleAccountMenu,
      toggleSearch: toggleSearchVisible,
      toggleSidebar: toggleSidebarVisible,
    }}>
      {children}
    </NavbarContext.Provider>
  )
}

export {
  NavbarContextProvider,
  NavbarContext
}
